import React, { MouseEvent } from "react";
import { styled } from "styled-components";
import Flex from "../../components/Box/Flex";
import { MotionBox } from "../../components/Box";
import { ArrowBackIcon, CloseIcon } from "../../components/Svg";
import { IconButton } from "../../components/Button";
import { ModalProps } from "./types";

export const mobileFooterHeight = 73;

export const ModalHeader = styled(Flex) <{ background?: string; headerBorderColor?: string }>`
  align-items: center;
  background: transparent;
  border-bottom: 1px solid ${({ theme, headerBorderColor }) => headerBorderColor || theme.colors.cardBorder};
  display: flex;
  padding: 18px 18px 10px;

  ${({ theme }) => theme.mediaQueries.md} {
    background: transparent; //${({ background }) => background || "transparent"};
  }
`;

export const ModalTitle = styled(Flex)`
  align-items: center;
  flex: 1;
  h2 {
    font-family: inherit;
  }
`;

export const ModalBody = styled(Flex)`
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(90vh - ${mobileFooterHeight}px);
  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
    // max-height: 90vh;
  }
`;

const CloseButton = styled(IconButton)`
  // border: 2px solid ${({ theme }) => theme.colors.primary};
  // border-radius: 100%;
  width: 40px;
  height: 40px;
`;

export const ModalCloseButton: React.FC<React.PropsWithChildren<{ onDismiss: ModalProps["onDismiss"] }>> = ({
  onDismiss,
}) => {
  return (
    <CloseButton
      variant="text"
      scale="sm"
      onClick={(e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onDismiss?.();
      }}
      aria-label="Close the dialog"
      mt={-2}
    >
      <CloseIcon color="text" width="20px" />
    </CloseButton>
  );
};

export const ModalBackButton: React.FC<React.PropsWithChildren<{ onBack: ModalProps["onBack"] }>> = ({ onBack }) => {
  return (
    <IconButton variant="text" onClick={onBack} aria-label="Go back" mr="8px">
      <ArrowBackIcon color="text" />
    </IconButton>
  );
};

export const ModalContainer = styled(MotionBox)<{ $isTopRight?: boolean }>`
  overflow: hidden;
  background: ${({ theme }) => theme.colors.backgroundAlt};
  box-shadow: 0 24px 64px -16px rgba(0, 0, 0, 0.7);
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  height: max-content;
  max-height: calc(var(--vh, 1vh) * 90);
  width: 100%; 
  max-width: 100%;
  border-radius: 24px;
  position: fixed;
  z-index: auto;
  &:last-child {
    z-index: ${({ theme }) => theme.zIndices.modal};
  }

  ${({ $isTopRight, theme }) =>
    $isTopRight
      ? `
        top: 60px;
        right: 10px;
        max-width: 400px;
      `
      : `
        border-radius: 24px 24px 0 0;
        bottom: 0;

        ${theme.mediaQueries.sm} {
          bottom: unset;
          max-width: min(600px, 80%);
          border-radius: 24px;
          width: auto;
        }
      `
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[0]}) {
    max-height: calc(var(--vh, 1vh) * 100);
  }
`;